var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "documents-doc-icon 1",
    clipPath: "url(#clip0_7505_1259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26 28C26 29.1 25.1 30 24 30H4C2.9 30 2 29.1 2 28V4C2 2.9 2.9 2 4 2H16V11C16 11.6 16.4 12 17 12H26V14H28V11L27.3 10.3L17.7 0.7L17 0H4C1.8 0 0 1.8 0 4V28C0 30.2 1.8 32 4 32H24C26.2 32 28 30.2 28 28V27H26V28ZM18 3.8L24.2 10H18V3.8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.8 16.9004H11.6V24.0004H13.6C14.9 24.0004 15.8 23.7004 16.5 23.1004C17.2 22.5004 17.5 21.6004 17.5 20.4004C17.5 19.3004 17.2 18.4004 16.5 17.8004C15.8 17.2004 14.9 16.9004 13.8 16.9004ZM13.7 22.8004H13V18.2004H13.8C15.2 18.2004 15.8 19.0004 15.8 20.5004C15.9 22.0004 15.1 22.8004 13.7 22.8004Z",
    fill: "#1B1C1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.5 17.8004C18.9 18.4004 18.6 19.3004 18.6 20.5004C18.6 21.7004 18.9 22.6004 19.5 23.2004C20.1 23.8004 20.9 24.2004 22 24.2004C23.1 24.2004 23.9 23.9004 24.5 23.2004C25.1 22.5004 25.4 21.7004 25.4 20.5004C25.4 19.3004 25.1 18.4004 24.5 17.8004C23.9 17.2004 23.1 16.9004 22 16.9004C20.9 16.9004 20.1 17.1004 19.5 17.8004ZM23.8 20.5004C23.8 22.1004 23.2 22.9004 22 22.9004C21.4 22.9004 20.9 22.7004 20.6 22.3004C20.3 21.9004 20.1 21.3004 20.1 20.5004C20.1 19.7004 20.3 19.1004 20.6 18.7004C20.9 18.3004 21.4 18.1004 22 18.1004C23.2 18.1004 23.8 18.9004 23.8 20.5004Z",
    fill: "#1B1C1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.1 20.4998C28.1 19.6998 28.3 19.0998 28.6 18.6998C28.9 18.2998 29.4 18.0998 29.9 18.0998C30.2 18.0998 30.4 18.0998 30.7 18.1998C31 18.2998 31.2 18.3998 31.5 18.4998L32 17.2998C31.3 16.9998 30.6 16.7998 29.9 16.7998C29.2 16.7998 28.6 16.8998 28.1 17.1998C27.6 17.4998 27.2 17.8998 26.9 18.4998C26.6 19.0998 26.5 19.6998 26.5 20.4998C26.5 21.6998 26.8 22.5998 27.3 23.1998C27.8 23.7998 28.6 24.0998 29.7 24.0998C30.4 24.0998 31.1 23.9998 31.7 23.6998V22.3998C31 22.6998 30.4 22.7998 29.9 22.7998C28.7 22.8998 28.1 22.0998 28.1 20.4998Z",
    fill: "#1B1C1F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7505_1259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/doc-icon.4639f600980c002f0a5dd9f612cb201e.svg";
export { ForwardRef as ReactComponent };